export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const FETCH_ALL = 'FETCH_ALL';
export const FETCH_BY_SEARCH = 'FETCH_BY_SEARCH';
export const FETCH_BY_USER = 'FETCH_BY_USER';
export const FETCH_POST = 'FETCH_POST'; // This was likely missing
export const LIKE = 'LIKE';
export const COMMENT = 'COMMENT';
export const SHARE = 'SHARE';

export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';

export const START_LOADING = 'START_LOADING';
export const END_LOADING = 'END_LOADING';
export const FETCH_USER = 'FETCH_USER';
export const FOLLOW = 'FOLLOW';